// extracted by mini-css-extract-plugin
module.exports = {"container":"EcosystemFilter_container__91HRF","title":"EcosystemFilter_title___Nh9R"};